import React, { useEffect, useState } from "react";
import Sidebaar from "../Component/Sidebar";
import TitleComp from "../Component/TitleComp";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import Select from "react-select";

import { Button, Col, Form, FormGroup, Modal } from "react-bootstrap";
import { Base_Url } from "../BaseUrl";
import { Bars } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import { compressImage } from "../Component/CompressImage";

function Brand() {
  const [categories, setCategories] = useState([]);
  const [name, setname] = useState("");
  const [file, setfile] = useState(null);
  const [idindex, setidindex] = useState("");
  const [editimg, seteditimg] = useState("");
  const [loading, setloading] = useState(false);
  const [brand, setbrand] = useState([]);
  const [brandvalue, setbrandvalue] = useState("");
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [activeBrand, setActiveBrand] = useState(null);

  let token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  // const handlesubmit = (e) => {
  //   setloading(true);
  //   e.preventDefault();
  //   let formdata = new FormData();

  //   formdata.append("name", name);
  //   if (file) {
  //     formdata.append("image", file);
  //   }
  //   selectedOptions.map((option, index) => {
  //     formdata.append(`category[${index}]`, option.value);
  //   });

  //   formdata.append("brand", brandvalue);
  //   if (idindex) {
  //     formdata.append("_id", idindex);
  //     axios.put(`${Base_Url}/brands`, formdata, { headers }).then((res) => {

  //       if (res.data !== null) {
  //         setloading(false);
  //         catgoryget();
  //         handleClear();
  //       }
  //     });
  //   } else {
  //     axios.post(`${Base_Url}/brands`, formdata, { headers }).then((res) => {

  //       if (res.data !== null) {
  //         setloading(false);
  //         catgoryget();
  //         handleClear();
  //       }
  //     });
  //   }
  // };


  const handlesubmit = (e) => {
    setloading(true);
    e.preventDefault();
    let formdata = new FormData();

    formdata.append("name", name);
    if (file) {
      compressImage(file).then((compressedFile) => {
        formdata.append("image", compressedFile);
        selectedOptions.map((option, index) => {
          formdata.append(`category[${index}]`, option.value);
        });

        formdata.append("brand", brandvalue);
        if (idindex) {
          formdata.append("_id", idindex);
          axios.put(`${Base_Url}/brands`, formdata, { headers }).then((res) => {
            if (res.data !== null) {
              setloading(false);
              catgoryget();
              handleClear();
            }
          });
        } else {
          axios.post(`${Base_Url}/brands`, formdata, { headers }).then((res) => {
            if (res.data !== null) {
              setloading(false);
              catgoryget();
              handleClear();
            }
          });
        }
      });
    }
  };




  const handleFile = (e) => {
    const selectedfile = e.target.files[[0]];

    setfile(selectedfile);
  };

  const catgoryget = () => {
    setloading(true);
    axios.get(`${Base_Url}/brands`, { headers }).then((res) => {
      setCategories(res.data.data);

      if (res.data != null) {
        setloading(false);
      }
    });
  };
  useEffect(() => {
    catgoryget();
  }, []);

  const handleedit = (e, id) => {
    e.preventDefault();

    // Filter categories based on the ID
    const editFilter = categories.find((cat) => cat?._id == id);

    if (editFilter) {
      setidindex(editFilter._id);
      seteditimg(editFilter.image);
      setbrandvalue(editFilter.brand?._id);
      // setSelectedOptions(editFilter.category._id);

      setname(editFilter.name);
      // Populate selectedOptions with the categories associated with the brand
      const selectedCategories = editFilter.category.map((cat) => ({
        value: cat._id,
        label: cat.name,
      }));
      setSelectedOptions(selectedCategories);
    }
  };

  const handleClear = () => {
    setname("");
    setfile(null);
    setbrandvalue("");
    setSelectedOptions("");
  };

  const getRowId = (row) => row._id;
  const columns = [
    { field: "name", headerName: "Name", flex: 1 },


    {
      field: "image",
      headerName: "image",
      flex: 1,
      renderCell: (params) => {
        const { value } = params;
        return (
          <img
            src={`${Base_Url}/${value}`}
            onClick={(e) => handleShow(e, value)}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
            }}
            className="img-fluid tableimgmui"
          ></img>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => {
        // const index = params.row.index; // Corrected to rowIndex
        const id = params.row._id;
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => handleedit(e, id)}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </span>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        const id = params.row._id; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              handleDelete(e, id);

            }}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
        );
      },
    },
  ];

  const brandget = () => {
    axios.get(`${Base_Url}/categories`, { headers }).then((res) => {
      // console.log(res.data.data);
      setbrand(res.data.data);
    });
  };

  useEffect(() => {
    brandget();
    if (categories) {
      setFilteredCategories(categories);
    }
  }, [categories]);

  const [selectedOptions, setSelectedOptions] = React.useState([]);


  const [imageurl, setimageurl] = useState("")


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (e, value) => {
    setShow(true)
    setimageurl(value)
  };

  // Handler for handling changes in selected values
  const handleSelectChange = (selectedValues) => {
    setSelectedOptions(selectedValues);
  };

  const options = brand.map((item) => ({
    value: item._id,
    label: item.name,
  }));

  const handlefilter = (e, selectedBrand) => {
    e.preventDefault();

    setActiveBrand(selectedBrand);
    // Filter categories based on selected brand's category IDs
    const filteredData = categories.filter((category) =>
      category.category.some((cat) => cat._id === selectedBrand._id)
    );
    setFilteredCategories(filteredData);
  };


  const notify = (message, type) => {
    // console.log("type", type);
    toast[type](message, {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };



  const handleDelete = (e, id) => {
    e.preventDefault();

    let requestdata = {
      _id: id,
      deleted_at: Math.floor(Date.now() / 1000),
    };

    axios
      .put(`${Base_Url}/brands`, requestdata, { headers })
      .then((res) => {
        // console.log(res);
        if (res.data.message === "Ok") {
          catgoryget();
          notify("Delete Successfully", "success");
          // console.log("Data", res.data);
        }
      })
      .catch((error) => {
        console.error("Error deleting:", error);
        notify("Error deleting", "error");
      });
  };

  return (
    <>
      {loading && (
        <div className="overlay">
          <Bars
            height="80"
            width="80"
            color="#051322"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      )}

      <Sidebaar
        content={
          <>
            <TitleComp title="Add  Brand " />
            <Form className="" onSubmit={(e) => handlesubmit(e)}>
              <div className="row align-items-center gy-3">
                {editimg && (
                  <Col md="12">
                    <div className="text-center mt-3 ">
                      <img
                        style={{ height: "50px" }}
                        src={`${Base_Url}/${editimg}`}
                        className="img-fluid rounded-2"
                      />
                    </div>
                  </Col>
                )}
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">
                      Image{" "}
                      {idindex ? "" : <span className="text-danger">*</span>}
                    </label>
                    <input
                      type="file"
                      required={idindex ? false : true}
                      onChange={(e) => handleFile(e)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setname(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>

                <Col md="4">
                  <label htmlFor="">Select Category</label>
                  <Select
                    options={options}
                    isMulti
                    value={selectedOptions}
                    onChange={handleSelectChange}
                  />
                </Col>
                <Col md="2">
                  <button className="btn mt-4 bg-dark text-white">
                    Submit{" "}
                  </button>
                </Col>
              </div>
            </Form>
            <div className="row mt-5 align-items-center">
              <div className="col-md-10">
                <div className="d-flex gap-3  overflowscroll">
                  {brand.map((item) => {
                    return (
                      <>
                        <button
                          key={item._id}
                          className={`btn px-5 rounded-pill ${activeBrand && activeBrand._id === item._id
                              ? " bgblackgrd text-white"
                              : "bgbluegrd text-white"
                            }`}
                          onClick={(e) => handlefilter(e, item)}

                        >
                          {item.name}
                        </button>
                      </>
                    );
                  })}
                </div>
              </div>
              <div className="col-md-2">
                <div className="text-end">
                  <button
                    className="btn bg-dark text-white"
                    onClick={(e) => {
                      setFilteredCategories(categories);
                      setActiveBrand(null);
                    }}
                  >
                    Show All
                  </button>
                </div>
              </div>
            </div>
            <Col md="12">
              <Box sx={{ height: 500, width: "100%" }}>
                <DataGrid
                  rows={filteredCategories.map((row, index) => ({
                    ...row,
                    index,
                  }))}
                  columns={columns}
                  pageSize={5}
                  getRowId={getRowId}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                />
              </Box>
            </Col>
            <ToastContainer />


            <Modal show={show} size="md" onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Image</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img src={`${Base_Url}/${imageurl}`} alt="" />
              </Modal.Body>
              <Modal.Footer>
                <Button className="text-write bg-secondary  shadow-none border-0" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        }
      />
    </>
  );
}

export default Brand;
